import React from "react";
import {Resource, Resources} from "../../enum/Resource";

import './ImageOasis.sass'

export function ImageOasis({ primary, is50, hasCrop, size }: { size: 16|32, primary: Resource, is50: boolean, hasCrop: boolean }) {
    let type = {
        [Resource.Wood]: 'lumber',
        [Resource.Clay]: 'clay',
        [Resource.Iron]: 'iron',
        [Resource.Crop]: 'crop',
    }[primary];
    if (is50) {
        type = `${type}-${type}`;
    } else if (hasCrop) {
        type = `${type}-crop`;
    }
    return <i className={`travianImageOasis oasis-${type} size-${size}`}></i>
}

export function ImageOasisGeneric({ oasis, size }: { size: 16|32, oasis: Resources }) {
    const bonusArray = Object.entries(oasis)
        .filter(([_, value]) => value > 0)
        .map(([resource, bonus]: [Resource, number]) => ({ resource, bonus }))

    // There are only icons for specific subsets of possible oasis configurations.
    if (bonusArray.length === 1) {
        const bonus = bonusArray[0];
        if (bonus.bonus === 25) {
            return <ImageOasis size={size} primary={bonus.resource} is50={false} hasCrop={false}/>;
        } else if (bonus.bonus === 50) {
            return <ImageOasis size={size} primary={bonus.resource} is50={true} hasCrop={false}/>;
        } else {
            return <div><ImageOasis size={size} primary={bonus.resource} is50={false} hasCrop={false}/> ${bonus.bonus}%</div>;
        }
    }

    if (bonusArray.length === 2
        && oasis[Resource.Crop] > 0
        && bonusArray[0].bonus === bonusArray[1].bonus
    ) {
        const bonus = bonusArray.find(bonus => bonus.resource !== Resource.Crop);
        if (bonus.bonus === 25) {
            return <ImageOasis size={size} primary={bonus.resource} is50={false} hasCrop={true}/>;
        } else {
            return <div><ImageOasis size={size} primary={bonus.resource} is50={false} hasCrop={true}/> ${bonus.bonus}%</div>;
        }
    }

    return <div>
        ${bonusArray.map((bonus, index) =>
        <div key={index}><ImageOasis size={size} primary={bonus.resource} is50={false} hasCrop={false}/> ${bonus.bonus}%</div>)}
    </div>
}
